import { useMutation, useQueryClient } from '@tanstack/vue-query'

import { deleteAdmin } from '../adminsEndpoints'
import { adminsQueryKeys } from '../adminsQueryKeys'

export function useDeleteAdminMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteAdmin(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminsQueryKeys.lists() })
    },
  })
}
